export const stellaRealDummyData = [
    {
        "journey": "work life balance",
        "expert_info": "This questionnaire was developed by Roshni Sondhi Abbi and Dr Samir Parikh, Adayu - A Fortis Network Company. It is designed to help you better understand your work life balance.",
        "opening_details": "Imagine yourself to be in the following situations and mark your answer based on how likely you are to respond in such a situation most of the time.",        
        "total_score": 100,
        "questions": [
          {
            "question_id": 1,
            "question": "What is your email ID?",
            "question_type": "Long-Text",
            "options": [],
            "require_response": true,
            "send_response": true,
            "add_score": false
          },
          {
            "question_id": 2,
            "question": "What is your age?",
            "question_type": "Long-Text",
            "options": [],
            "require_response": true,
            "send_response": true,
            "add_score": false
          },
          {
            "question_id": 3,
            "question": "The skills I developed at work have helped me in my personal life.",
            "category": "Gains",          
            "question_type": "single_select",
            "options": [
              {
                "button_id": "1",
                "text": "Strongly Agree",
                "score": 5
              },
              {
                "button_id": "2",
                "text": "Agree",
                "score": 4
              },
              {
                "button_id": "3",
                "text": "Neither Agree nor Disagree",
                "score": 3
              },
              {
                "button_id": "4",
                "text": "Disagree",
                "score": 2
              },
              {
                "button_id": "5",
                "text": "Strongly Disagree",
                "score": 1
              }
            ],
            "require_response":false,
            "send_response":false,
            "add_score": true
          },
          {
            "question_id": 4,
            "question": "I often find it difficult to focus on work due to other responsibilities.",
            "category": "Engagement",          
            "question_type": "single_select",
            "options": [
              {
                "button_id": "1",
                "text": "Strongly Agree",
                "score": 1
              },
              {
                "button_id": "2",
                "text": "Agree",
                "score": 2
              },
              {
                "button_id": "3",
                "text": "Neither Agree nor Disagree",
                "score": 3
              },
              {
                "button_id": "4",
                "text": "Disagree",
                "score": 4
              },
              {
                "button_id": "5",
                "text": "Strongly Disagree",
                "score": 5
              },            
            ],
            "require_response":false,
            "send_response":false,
            "add_score": true
          },
          {
            "question_id": 5,
            "question": "My ability to delegate tasks at work has made me more efficient in managing non-work tasks.",
            "category": "Enhanced functioning",          
            "question_type": "single_select",
            "options": [
              {
                "button_id": "1",
                "text": "Strongly Agree",
                "score": 5
              },
              {
                "button_id": "2",
                "text": "Agree",
                "score": 4
              },
              {
                "button_id": "3",
                "text": "Neither Agree nor Disagree",
                "score": 3
              },
              {
                "button_id": "4",
                "text": "Disagree",
                "score": 2
              },
              {
                "button_id": "5",
                "text": "Strongly Disagree",
                "score": 1
              }
            ],
            "require_response":false,
            "send_response":false,
            "add_score": true
          },
          {
            "question_id": 6,
            "question": "I often struggle to maintain boundaries between work and personal life.",
            "category": "Engagement",          
            "question_type": "single_select",
            "options": [
              {
                "button_id": "1",
                "text": "Strongly Agree",
                "score": 1
              },
              {
                "button_id": "2",
                "text": "Agree",
                "score": 2
              },
              {
                "button_id": "3",
                "text": "Neither Agree nor Disagree",
                "score": 3
              },
              {
                "button_id": "4",
                "text": "Disagree",
                "score": 4
              },
              {
                "button_id": "5",
                "text": "Strongly Disagree",
                "score": 5
              }
            ],
            "require_response":false,
            "send_response":false,
            "add_score": true
          },
          {
            "question_id": 7,
            "question": "Calls from work frequently interrupt the time I spend in non-work activities.",
            "category": "Balance",          
            "question_type": "single_select",
            "options": [
              {
                "button_id": "1",
                "text": "Strongly Agree",
                "score": 1
              },
              {
                "button_id": "2",
                "text": "Agree",
                "score": 2
              },
              {
                "button_id": "3",
                "text": "Neither Agree nor Disagree",
                "score": 3
              },
              {
                "button_id": "4",
                "text": "Disagree",
                "score": 4
              },
              {
                "button_id": "5",
                "text": "Strongly Disagree",
                "score": 5
              },
            ],
            "require_response":false,
            "send_response":true,
            "add_score": true
          },
          {
            "question_id": 8,
            "question": "The communication skills I use with my family have helped me communicate better with my team at work.",
            "category": "Gains",          
            "question_type": "single_select",
            "options": [
              {
                "button_id": "1",
                "text": "Strongly Agree",
                "score": 5
              },
              {
                "button_id": "2",
                "text": "Agree",
                "score": 4
              },
              {
                "button_id": "3",
                "text": "Neither Agree nor Disagree",
                "score": 3
              },
              {
                "button_id": "4",
                "text": "Disagree",
                "score": 2
              },
              {
                "button_id": "5",
                "text": "Strongly Disagree",
                "score": 1
              },
            ],
            "require_response":true,
            "send_response":false,
            "add_score": true
          },
          {
            "question_id": 9,
            "question": "If find it hard to separate my mood at work from my mood at home.",
            "category": "Enhanced functioning",          
            "question_type": "single_select",
            "options": [
              {
                "button_id": "1",
                "text": "Strongly Agree",
                "score": 1
              },
              {
                "button_id": "2",
                "text": "Agree",
                "score": 2
              },
              {
                "button_id": "3",
                "text": "Neither Agree nor Disagree",
                "score": 3
              },
              {
                "button_id": "4",
                "text": "Disagree",
                "score": 4
              },
              {
                "button_id": "5",
                "text": "Strongly Disagree",
                "score": 5
              },
            ],
            "require_response":true,
            "send_response":false,
            "add_score": true
          },
          {
            "question_id": 10,
            "question": "My non-work commitments do not interfere with my ability to concentrate at work.",
            "category": "Balance",          
            "question_type": "single_select",
            "options": [
              {
                "button_id": "1",
                "text": "Strongly Agree",
                "score": 5
              },
              {
                "button_id": "2",
                "text": "Agree",
                "score": 4
              },
              {
                "button_id": "3",
                "text": "Neither Agree nor Disagree",
                "score": 3
              },
              {
                "button_id": "4",
                "text": "Disagree",
                "score": 2
              },
              {
                "button_id": "5",
                "text": "Strongly Disagree",
                "score": 1
              },
            ],
            "require_response":true,
            "send_response":false,
            "add_score": true
          },
          {
            "question_id": 11,
            "question": "Problem-solving at work has improved my ability to handle challenges in other areas of my life.",
            "category": "Gains",          
            "question_type": "single_select",
            "options": [
              {
                "button_id": "1",
                "text": "Strongly Agree",
                "score": 5
              },
              {
                "button_id": "2",
                "text": "Agree",
                "score": 4
              },
              {
                "button_id": "3",
                "text": "Neither Agree nor Disagree",
                "score": 3
              },
              {
                "button_id": "4",
                "text": "Disagree",
                "score": 2
              },
              {
                "button_id": "5",
                "text": "Strongly Disagree",
                "score": 1
              },
            ],
            "require_response":true,
            "send_response":false,
            "add_score": true
          },
          {
            "question_id": 12,
            "question": "Having a fulfilling personal life makes me more productive at work.",
            "category": "Gains",          
            "question_type": "single_select",
            "options": [
              {
                "button_id": "1",
                "text": "Strongly Agree",
                "score": 5
              },
              {
                "button_id": "2",
                "text": "Agree",
                "score": 4
              },
              {
                "button_id": "3",
                "text": "Neither Agree nor Disagree",
                "score": 3
              },
              {
                "button_id": "4",
                "text": "Disagree",
                "score": 2
              },
              {
                "button_id": "5",
                "text": "Strongly Disagree",
                "score": 1
              },
            ],
            "require_response":true,
            "send_response":false,
            "add_score": true
          },
          {
            "question_id": 13,
            "question": "I derive equal satisfaction from both my work and non-work life.",
            "category": "Balance",          
            "question_type": "single_select",
            "options": [
              {
                "button_id": "1",
                "text": "Strongly Agree",
                "score": 5
              },
              {
                "button_id": "2",
                "text": "Agree",
                "score": 4
              },
              {
                "button_id": "3",
                "text": "Neither Agree nor Disagree",
                "score": 3
              },
              {
                "button_id": "4",
                "text": "Disagree",
                "score": 2
              },
              {
                "button_id": "5",
                "text": "Strongly Disagree",
                "score": 1
              },
            ],
            "require_response":true,
            "send_response":false,
            "add_score": true
          },
          {
            "question_id": 14,
            "question": "I feel pressured to prioritize work over personal commitments.",
            "category": "Engagement",          
            "question_type": "single_select",
            "options": [
              {
                "button_id": "1",
                "text": "Strongly Agree",
                "score": 1
              },
              {
                "button_id": "2",
                "text": "Agree",
                "score": 2
              },
              {
                "button_id": "3",
                "text": "Neither Agree nor Disagree",
                "score": 3
              },
              {
                "button_id": "4",
                "text": "Disagree",
                "score": 4
              },
              {
                "button_id": "5",
                "text": "Strongly Disagree",
                "score": 5
              },            
            ],
            "require_response":true,
            "send_response":false,
            "add_score": true
          },
          {
            "question_id": 15,
            "question": "I find socializing outside of work helps me manage stress better.",
            "category": "Enhanced functioning",          
            "question_type": "single_select",
            "options": [
              {
                "button_id": "1",
                "text": "Strongly Agree",
                "score": 5
              },
              {
                "button_id": "2",
                "text": "Agree",
                "score": 4
              },
              {
                "button_id": "3",
                "text": "Neither Agree nor Disagree",
                "score": 3
              },
              {
                "button_id": "4",
                "text": "Disagree",
                "score": 2
              },
              {
                "button_id": "5",
                "text": "Strongly Disagree",
                "score": 1
              },
            ],
            "require_response":true,
            "send_response":false,
            "add_score": true
          },
          {
            "question_id": 16,
            "question": "My network at work has helped me build connections in my personal life.",
            "category": "Gains",          
            "question_type": "single_select",
            "options": [
              {
                "button_id": "1",
                "text": "Strongly Agree",
                "score": 5
              },
              {
                "button_id": "2",
                "text": "Agree",
                "score": 4
              },
              {
                "button_id": "3",
                "text": "Neither Agree nor Disagree",
                "score": 3
              },
              {
                "button_id": "4",
                "text": "Disagree",
                "score": 2
              },
              {
                "button_id": "5",
                "text": "Strongly Disagree",
                "score": 1
              },
            ],
            "require_response":true,
            "send_response":false,
            "add_score": true
          },
          {
            "question_id": 17,
            "question": "My work and personal life do not interfere with each other.",
            "category": "Balance",          
            "question_type": "single_select",
            "options": [
              {
                "button_id": "1",
                "text": "Strongly Agree",
                "score": 5
              },
              {
                "button_id": "2",
                "text": "Agree",
                "score": 4
              },
              {
                "button_id": "3",
                "text": "Neither Agree nor Disagree",
                "score": 3
              },
              {
                "button_id": "4",
                "text": "Disagree",
                "score": 2
              },
              {
                "button_id": "5",
                "text": "Strongly Disagree",
                "score": 1
              },
            ],
            "require_response":true,
            "send_response":false,
            "add_score": true
          },
          {
            "question_id": 18,
            "question": "I spend approximately equal time at my workplace as compared to non-work areas.",
            "category": "Engagement",          
            "question_type": "single_select",
            "options": [
              {
                "button_id": "1",
                "text": "Strongly Agree",
                "score": 5
              },
              {
                "button_id": "2",
                "text": "Agree",
                "score": 4
              },
              {
                "button_id": "3",
                "text": "Neither Agree nor Disagree",
                "score": 3
              },
              {
                "button_id": "4",
                "text": "Disagree",
                "score": 2
              },
              {
                "button_id": "5",
                "text": "Strongly Disagree",
                "score": 1
              },
            ],
            "require_response":true,
            "send_response":false,
            "add_score": true
          },
                    {
            "question_id": 19,
            "question": "Learning to delegate work in my team has helped me become more productive outside of work also.",
            "category": "Enhanced functioning",          
            "question_type": "single_select",
            "options": [
              {
                "button_id": "1",
                "text": "Strongly Agree",
                "score": 5
              },
              {
                "button_id": "2",
                "text": "Agree",
                "score": 4
              },
              {
                "button_id": "3",
                "text": "Neither Agree nor Disagree",
                "score": 3
              },
              {
                "button_id": "4",
                "text": "Disagree",
                "score": 2
              },
              {
                "button_id": "5",
                "text": "Strongly Disagree",
                "score": 1
              },
            ],
            "require_response":true,
            "send_response":true,
            "add_score": true
          },
  
          {
            "question_id": 20,
            "question": "A problem at home has less impact on me than a problem at the workplace.",
            "category": "Engagement",          
            "question_type": "single_select",
            "options": [
              {
                "button_id": "1",
                "text": "Strongly Agree",
                "score": 1
              },
              {
                "button_id": "2",
                "text": "Agree",
                "score": 2
              },
              {
                "button_id": "3",
                "text": "Neither Agree nor Disagree",
                "score": 3
              },
              {
                "button_id": "4",
                "text": "Disagree",
                "score": 4
              },
              {
                "button_id": "5",
                "text": "Strongly Disagree",
                "score": 5
              },            
            ],
            "require_response":true,
            "send_response":false,
            "add_score": true
          },
          {
            "question_id": 21,
            "question": "I often struggle to choose between spending time on work or non-work activities.",
            "category": "Balance",          
            "question_type": "single_select",
            "options": [
              {
                "button_id": "1",
                "text": "Strongly Agree",
                "score": 1
              },
              {
                "button_id": "2",
                "text": "Agree",
                "score": 2
              },
              {
                "button_id": "3",
                "text": "Neither Agree nor Disagree",
                "score": 3
              },
              {
                "button_id": "4",
                "text": "Disagree",
                "score": 4
              },
              {
                "button_id": "5",
                "text": "Strongly Disagree",
                "score": 5
              },            
            ],
            "require_response":true,
            "send_response":false,
            "add_score": true
          },
          {
            "question_id": 22,
            "question": "I find it easier to manage my staff at home because of what I have learnt from managing my team at work.",
            "category": "Enhanced functioning",          
            "question_type": "single_select",
            "options": [
              {
                "button_id": "1",
                "text": "Strongly Agree",
                "score": 5
              },
              {
                "button_id": "2",
                "text": "Agree",
                "score": 4
              },
              {
                "button_id": "3",
                "text": "Neither Agree nor Disagree",
                "score": 3
              },
              {
                "button_id": "4",
                "text": "Disagree",
                "score": 2
              },
              {
                "button_id": "5",
                "text": "Strongly Disagree",
                "score": 1
              },
            ],
            "require_response":true,
            "send_response":false,
            "add_score": true
          },
        ],
        "recommendation": [
          {
            "lower": 0,
            "upper": 13,
            "text": "Your scores indicate minimal levels of clinical anger.",
            "expert_suggestion":[
              {
                "title":"Healing With Meditation",
                "exp_image":"https://firebasestorage.googleapis.com/v0/b/united-for-her.appspot.com/o/odoo%2Fcourses%2Fthumbnails%2FHealing%20With%20Meditation-min.png?alt=media",
                "session_link":"https://my.unitedwecare.com/course/details/2/?utm_source=com&utm_medium=website&utm_campaign=search&utm_content=course_button_click",
                "experience":"",
                "profession":"",
                "type":"Course",
                "language":["English"]
              },
              {
                "title":"Meditation for a 9-5 Life",
                "exp_image":"https://firebasestorage.googleapis.com/v0/b/united-for-her.appspot.com/o/odoo%2Fcourses%2Fthumbnails%2FGet%20Started%20With%20Mindfulness-min.png?alt=media",
                "session_link":"https://my.unitedwecare.com/course/details/55/?utm_source=com&utm_medium=website&utm_campaign=search&utm_content=course_button_click",
                "experience":"",
                "profession":"",
                "type":"Course",
                "language":["English"]
              }
            ]
          },
          {
            "lower": 14,
            "upper": 19,
            "text": "Your scores indicate mild clinical anger.",
            "expert_suggestion":[
              {
                "title":"Healing With Meditation",
                "exp_image":"https://firebasestorage.googleapis.com/v0/b/united-for-her.appspot.com/o/odoo%2Fcourses%2Fthumbnails%2FHealing%20With%20Meditation-min.png?alt=media",
                "session_link":"https://my.unitedwecare.com/course/details/2/?utm_source=com&utm_medium=website&utm_campaign=search&utm_content=course_button_click",
                "experience":"",
                "profession":"",
                "type":"Course",
                "language":["English"]
              },
              {
                "title":"Meditation for a 9-5 Life",
                "exp_image":"https://firebasestorage.googleapis.com/v0/b/united-for-her.appspot.com/o/odoo%2Fcourses%2Fthumbnails%2FGet%20Started%20With%20Mindfulness-min.png?alt=media",
                "session_link":"https://my.unitedwecare.com/course/details/2/?utm_source=com&utm_medium=website&utm_campaign=search&utm_content=course_button_click",
                "experience":"",
                "profession":"",
                "type":"Course",
                "language":["English"]
              }
            ]
          },
          {
            "lower": 20,
            "upper": 28,
            "text": "Your scores indicate moderate levels of clinical anger.",
            "expert_suggestion":[
              {
                "title":"Seema Taneja",
                "exp_image":"https://app.uwc.world/Content/Upload/2021/2/ewexmyrvfjx.jpg",
                "session_link":"https://my.unitedwecare.com/profession/Psychologist/SEEMA%20TANEJA/5833",
                "experience":"30 years",
                "profession":"Psychologist, therapy, self help + relaxation techniques",
                "type":"Professional",
                "language":["English","Hindi","Bengali"]
              },
              {
                "title":"Preethi Jain",
                "exp_image":"https://app.uwc.world/Content/Upload/2022/10/tce5qjlocdg.jpg",
                "session_link":"https://my.unitedwecare.com/profession/Psychologist/Preethi%20Jain%20/29246",
                "experience":"15 years",
                "profession":"Psychologist, therapy, self help + relaxation techniques",
                "type":"Professional",
                "language":["English","Hindi","Bengali"]
              },
              {
                "title":"Bhavna Barmi",
                "exp_image":"https://app.uwc.world/Content/Upload/2021/2/np5mlr20qec.jpg",
                "session_link":"https://my.unitedwecare.com/profession/Psychologist/Bhavna%20Barmi/7412",
                "experience":"25 years",
                "profession":"Psychologist, therapy, self help + relaxation techniques",
                "type":"Professional",
                "language":["English","Hindi","Bengali"]
              }
            ]
          },
          {
            "lower": 28,
            "upper": 63,
            "text": "Your results indicate severe clinical anger.",
            "expert_suggestion":[
              {
                "title":"Jateen Ukrani",
                "exp_image":"https://app.uwc.world/Content/Upload/2022/6/jd2k3i511y1.jpg",
                "session_link":"https://my.unitedwecare.com/profession/Psychiatrist/Jateen%20Ukrani/24400",
                "experience":"10 years",
                "profession":"Psychiatrist",
                "type":"Professional",
                "language":["English","Hindi","Bengali"]
              },
              {
                "title":"Dr Sneha V",
                "exp_image":"https://app.uwc.world/Content/Upload/2023/3/jgzikkyl4c5.jpg",
                "session_link":"https://my.unitedwecare.com/profession/Psychiatrist/Dr%20Sneha%20V/30803",
                "experience":"03 years",
                "profession":"Psychiatrist",
                "type":"Professional",
                "language":["English","Hindi","Bengali"]
              },
              {
                "title":"Anuj Khandelwal",
                "exp_image":"https://app.uwc.world/Content/Upload/2022/6/u51aji41jyv.jpg",
                "session_link":"https://my.unitedwecare.com/profession/Psychiatrist/Anuj%20Khandelwal/20746",
                "experience":"10 years",
                "profession":"Psychiatrist",
                "type":"Professional",
                "language":["English","Hindi","Bengali"]
              },
            ]
          }
        ],
        "interpretations": [
        {
          "Enhanced functioning": {
            "Low": "Your self-evaluation suggests that there is a need for you to transfer learning in specific skills from one field to another. You could try to extend the skills like problem solving, time management, delegation, decision making skills and communication that you learn at work to other non-work areas and vice versa. Such improvements in functioning could be facilitated from various aspects of functioning in life.",
            "Moderate": "Your self-evaluation suggests that you are able to apply and transfer skills from one area of functioning to improve your functioning in other areas of life. This could be from work areas to other non-work-related areas or vice versa. Your communication skills, problem solving skills, delegation and other skills that you are equipped with could also be beneficial when applied to other areas of functioning, thereby facilitating a balance in enhancements across fields. You are moderately successful in applying lessons learned in one role to another. Being more intentional about skill transfer can enhance overall functioning.",
            "High": "Your self-evaluation suggests that you seem to transfer skills across areas of functioning, contributing towards positive improvements in various specific domains. These could include delegating skills, managerial skills, problem solving, communication skills and so on. Such a facilitation can be helpful not only in balancing the learning through various fields, and working towards an enhanced functioning in specific skill sets at work and non-work-related areas. You seamlessly integrate learning from both domains, making you adaptable and efficient. Maintaining a growth mindset can further strengthen this balance."
          },
          "Engagement": {
            "Low": "Your self-evaluation indicates that your active efforts of engagement towards your work and non-work-related roles are not achieving a state of balance. You spend an unequal amount of time, energy or efforts towards completing your work demands as compared to your other non-work-related areas of life. It could be recommended that you try to re-evaluate your investment towards work as well as other areas of functioning including personal life, social life, familial life, etc. It is ideal to try and strike a balance between not just the time spent on work and non-work areas of life, but also the amount of effort and energy spent on both these aspects of life. Identifying specific barriers to engagement and setting clear priorities can help.",
            "Moderate": "Your self-evaluation indicates the presence of a likely balance between your invested efforts being divided between your work and non-work-related activities. This means that you are likely to spend almost equal efforts, including your time and energy engaging in both work and non-work-related activities, for most of the times. It could be helpful for you to take a step back and notice the patterns, if any, when you need to invest more than usual efforts towards either your work or any other demands; you can consider exploring its impact on other aspects of functioning, and minimizing any such interference by striving for a balance. Structuring time more effectively and improving focus in each domain could enhance overall satisfaction.",
            "High": "Your self-evaluation indicates the presence of a well-balanced approach in the investment of your energies towards both work and non-work-related activities. This means that your time, effort, energy and resources seem to be almost equally divided between the demands from your workplace as well as other areas of functioning. You could also explore how the opportunities, skills and experiences gained in one area of work are helping you facilitate on your engagement and contribution in other areas life. Keep reinforcing positive engagement habits while ensuring long-term sustainability."
          },
          "Gains": {
            "Low": "Your self-evaluation indicates a need for you to capitalize on gains from your work onto other non-work-related areas of functioning, and vice-versa. You can try and apply the skills and knowledge gained at one of these areas to another area’s work. An achievement or a positive development at work can be utilized to improve your mood in other areas of life as well, possibly making you more efficient or productive at home.",
            "Moderate": "Your self-evaluation indicates the presence of some gains being developed between various areas of functioning in your life, including work as well as non-work-related areas. You could be applying the skills and knowledge you acquired in one are to other areas of life. Your mood or behaviour in one area of work is likely to be impacting your mood or behaviour in other areas as well. It could be helpful to strive to improve your efficiency in any specific role by trying to make gains from other roles you play in life. Finding more structured ways to enhance cross-domain learning can improve this further.",
            "High": "Your self-evaluation suggests that the skills, knowledge, or perspectives you gain from one area of functioning often seem to help you in other areas of functioning as well. This means that what you learn at your workplace tends to help you in other non-work-related areas of life as well. And, vice-versa, the knowledge and resources you have from non-work areas tend to help you at your work. Such gains between areas of life could also be reflected in your mood, your behaviour or your productivity levels. It can be helpful for you to explore if there are any additional benefits that you can transfer from either role of your life to another. This can help facilitate your growth as well as a sense of balance between work and non-work-related areas."
          },
          "Balance": {
            "Low": "Your self-evaluation reflects the need for a balance between your time and psychological involvement at work roles as well as non-work-related roles. You do not seem to be equally satisfied in both areas of functioning. This could also suggest the presence of interference from one of these areas of life spilling over into other areas. Frequent conflicts between work and personal life may be causing stress. Creating better boundaries and prioritizing self-care can help. It is recommended that you evaluate the aspects of functioning in which such an interference is being experienced, and try to reduce the conflicts between the roles.",
            "Moderate": "Your self-evaluation reflects the presence of a balance between the time, effort towards a psychological involvement and satisfaction being sought from both work and non-work-related activities. This also seems to suggest that there is not much interference experienced between these areas of functioning, at most times. You have a reasonable level of balance but may still experience occasional interference between roles. Strengthening time management and communication skills could improve harmony. It could be helpful for you to be on the lookout for any such interference or conflict experienced. In such cases, you can try to identify the source, while making efforts to minimize their impact on your functioning in other areas.",
            "High": "Your self-evaluation reflects a well-balanced approach of your psychological involvement and time being spent between your work roles and non-work roles. This indicates that there is not just a focus on equality of your engagement between these areas of functioning, but also a lack of any interference from each of these areas onto the others. You also seem to have a balanced level of satisfaction being derived from both roles. It can be helpful for you to explore the benefits of such a balance in your work-life, extending to other areas of functioning."
          }
        }
      ]
      }
  ]